import { DashboardWithoutSidebar } from 'packages/kakapo-ui-application/pages/dashboard/Dashboard';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

export default function Analytics() {
	const { t } = useTranslation();

	return (
		<>
			<Helmet>
				<title>{t('analytics.page.title')}</title>
			</Helmet>
			<DashboardWithoutSidebar />
		</>
	);
}
